import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingFAQForm(props) {
  return <SpaceRoleRangeForm {...props} role="faq" settingKey="faq_role_setting" />;
}

export default SpacesSettingFAQForm;
